<div *ngIf="!jobProgress">
	<h3>En attente des informations...</h3>
	<mat-progress-bar
		 [mode]="'determinate'"
		 [value]="0"
		 >
	</mat-progress-bar>
</div>
<div *ngIf="jobProgress as progress">
	<h3>
		{{ progress.label }}: {{ progress.processedCount }} / {{ progress.totalCount }}
		<span *ngIf="progress.status === status.UNKNOWN" style="font-weight: bold; color:black">- Reception des informations en attente</span>
		<span *ngIf="progress.status === status.COMPLETED" style="font-weight: bold; color:green">- Terminé</span>
		<span *ngIf="progress.status === status.FAILED" style="font-weight: bold; color:red">- Erreur!</span>
	</h3>
	<mat-progress-bar
		 [mode]="'determinate'"
		 [value]="(progress.processedCount * 100 / progress.totalCount)"
		 >
	</mat-progress-bar>
</div>